__turbopack_context__.v({
  "animated": "Trustedby-module__WiYjFW__animated",
  "badge": "Trustedby-module__WiYjFW__badge",
  "header": "Trustedby-module__WiYjFW__header",
  "learnMore": "Trustedby-module__WiYjFW__learnMore",
  "leftSide": "Trustedby-module__WiYjFW__leftSide",
  "reveal-up": "Trustedby-module__WiYjFW__reveal-up",
  "rightSide": "Trustedby-module__WiYjFW__rightSide",
  "subHeader": "Trustedby-module__WiYjFW__subHeader",
  "trustedByContainer": "Trustedby-module__WiYjFW__trustedByContainer",
  "visualHeader": "Trustedby-module__WiYjFW__visualHeader",
});
